import React from 'react';

import headerImage from '@images/header-images/blog-header.svg';

import * as styles from './styles.module.scss';

export const blogHeaderProps = {
  backgroundImage: headerImage,
  backgroundImageAlt: 'CodiLime network and cloud expertise',
  title: 'Blog',
  subtitle: <span className={styles.subtitleBackground}>Our network and cloud expertise</span>,
  subtitleBorderWidth: styles.subtitleBorder,
};
